// Файл api_contracts.js



/**
 * @typedef {Object} DfRequest
 * @property {string} table_name
 * @property {*} [params]
 * @property {*} [table_data]
 * @property {Array<string>} [table_columns]
 * @property {string} [table_path]
 * @property {*} [save_params]
 */

/**
 * @typedef {Object} DfResponse
 * @property {Array<string>} [columns]
 * @property {*} [data]
 * @property {string} [response]
 * @property {string} [error]
 */

const endpoint_name_pattern = /^[a-zA-Z0-9_-]+$/;


export const validate_df_request = (request_data) => {
    const table_name = String(request_data?.table_name || '').trim();

    if (!table_name || !endpoint_name_pattern.test(table_name)) {
        throw new Error(
            `Некорректное имя API-контракта: ${table_name || '<пусто>'}`
        );
    }

    return table_name;
};


export const validate_df_response = (table_name, response_data) => {
    if (response_data === undefined) {
        throw new Error(`API ${table_name} вернул пустой ответ`);
    }

    if (
        response_data
        && typeof response_data === 'object'
        && !Array.isArray(response_data)
    ) {
        if (
            Object.prototype.hasOwnProperty.call(response_data, 'columns')
            && !Array.isArray(response_data.columns)
        ) {
            throw new Error(
                `API ${table_name}: поле columns должно быть массивом`
            );
        }

        if (
            Object.prototype.hasOwnProperty.call(response_data, 'error')
            && typeof response_data.error !== 'string'
        ) {
            throw new Error(
                `API ${table_name}: поле error должно быть строкой`
            );
        }
    }

    return response_data;
};